import request from '@/utils/request'
import { ADMIN_SERVICE_URL } from '@/utils/constant'
export function list(queryParams) {
  return request({
    url: `${ADMIN_SERVICE_URL}/dict-types`,
    method: 'get',
    params: queryParams
  })
}

export function detail(id) {
  return request({
    url: `${ADMIN_SERVICE_URL}/dict-types/` + id,
    method: 'get'
  })
}

export function add(data) {
  return request({
    url: `${ADMIN_SERVICE_URL}/dict-types`,
    method: 'post',
    data: data
  })
}

export function update(id, data) {
  return request({
    url: `${ADMIN_SERVICE_URL}/dict-types/` + id,
    method: 'put',
    data: data
  })
}

export function del(ids) {
  return request({
    url: `${ADMIN_SERVICE_URL}/dict-types`,
    method: 'delete',
    params: { ids: ids }
  })
}

export function patch(id, data) {
  return request({
    url: `${ADMIN_SERVICE_URL}/dict-types/` + id,
    method: 'patch',
    data: data
  })
}
